// extracted by mini-css-extract-plugin
export var contentGrid = "_r-3";
export var divider = "_r-t";
export var emailInput = "_r-8";
export var emptyDescription = "_r-z";
export var emptyState = "_r-x";
export var emptyTitle = "_r-y";
export var fadeIn = "_r-10";
export var formCard = "_r-5";
export var formGroup = "_r-7";
export var helperText = "_r-9";
export var imagePlaceholder = "_r-n";
export var itemDetails = "_r-l";
export var itemImage = "_r-m";
export var itemInfo = "_r-p";
export var itemName = "_r-q";
export var itemPrice = "_r-s";
export var itemQuantity = "_r-r";
export var itemsList = "_r-j";
export var mainContent = "_r-4";
export var orderItem = "_r-k";
export var orderSummaryCard = "_r-i";
export var pageContainer = "_r-0";
export var pageHeader = "_r-1";
export var pageTitle = "_r-2";
export var paymentDescription = "_r-e";
export var paymentIcon = "_r-b";
export var paymentInfo = "_r-a";
export var paymentMethods = "_r-f";
export var paymentText = "_r-d";
export var placeholderText = "_r-o";
export var sectionTitle = "_r-6";
export var sidebarContent = "_r-h";
export var stripeIcon = "_r-c";
export var submitButton = "_r-g";
export var totalAmount = "_r-w";
export var totalLabel = "_r-v";
export var totalRow = "_r-u";